module.exports = __webpack_public_path__ + "img/save.b617ccd6.svg";